import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, watch, computed, useContext } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { GETTERS as GETTERS_PURCHASE } from "~/store/affility/purchase/names";

interface Props {
    visible?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseAutoship',
  props: {
    visible: { type: Boolean }
  },
  emits: ['input', 'onPopupClose'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { visible?: boolean };





const {
    visible,
} = toRefs(props);

const isMobile = useMobile();
const { store } = useContext();

const internalVisible = ref(visible.value);
const purchaseData = computed(() => store.getters[`affility/purchase/${GETTERS_PURCHASE.BUY_AUTOSHIP_DATA}`]);

const handleClosePurchasePopup = () => {
    $emit('onPopupClose');
}

watch(visible, (value) => {
    internalVisible.value = value;
});

watch(internalVisible, (value) => {
    if (value === visible.value) {
        return;
    }
    $emit('input', value);
});

return { __sfc: true,props, $emit, visible, isMobile, store, internalVisible, purchaseData, handleClosePurchasePopup }
}

})